import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const DebtAmountProcessPayloadSchema = z.object({
    ratio: z.number().optional(),
    newDebt: z.number().optional(),
});

export class DebtAmountProcessPayload extends FromSchema(DebtAmountProcessPayloadSchema) {
    ratio?: number;
    newDebt?: number;
    // TODO what about 'in the last 3 months'?
}
